export default __webpack_public_path__ + "e03aa15c56a6341c1ad381794dc29598.png";